import { gql } from '@apollo/client';

export const CLEAR_SORTER_BAG_IDS = gql`
    mutation ClearSorterBagIds($sorterId: Long!) {
        clearSorterBagIds(sorterId: $sorterId)
    }
`;
